var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"appear":"","name":"fade","mode":"out-in"}},[_c('router-view',{key:_vm.name})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }